import { Flex } from "@redotech/redo-web/flex";
import { AnimatedSkeletonBlock } from "@redotech/redo-web/skeleton";

interface RateSourceSelectionOptionSkeletonProps {
  width: string;
}

export function RateSourceSelectionOptionSkeleton({
  width,
}: RateSourceSelectionOptionSkeletonProps) {
  return (
    <Flex align="center" gap="sm">
      <AnimatedSkeletonBlock height="12px" width="12px" />
      <AnimatedSkeletonBlock height="14px" width={width} />
    </Flex>
  );
}
